
const FooterExtraForm = () => null;
export default FooterExtraForm;
